// useFilterSortPagination with url search parameter handling for filters
import { useSearchParams } from "react-router";
import { useFilterSortPagination } from "@sscs/ui";
import { paramSerializer } from "Utils";

export const useFilterSortPaginationWithUrl: typeof useFilterSortPagination = (
  ...args
) => {
  const setSearchParams = useSearchParams()[1];

  const filterSortPagination = useFilterSortPagination(...args);

  const handleFilterChange: typeof filterSortPagination.handleFilterChange = (
    filter,
  ) => {
    const params = paramSerializer(filter);
    setSearchParams(params);
    return filterSortPagination.handleFilterChange(filter);
  };

  return {
    ...filterSortPagination,
    handleFilterChange,
  };
};

export default useFilterSortPaginationWithUrl;
